// extracted by mini-css-extract-plugin
module.exports = {"primary":"primary-2PYHd","secondary":"secondary-FKZH_"};